
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.439216 0 0 0 0 0.447059 0 0 0 0 0.450980 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","d":"M26.8 9.867L22.133 5.2c-.8-.8-1.733-1.2-2.8-1.2h-6.666c-1.067 0-2.134.4-2.8 1.2L5.2 9.867c-.8.8-1.2 1.733-1.2 2.8v6.666c0 1.067.4 2.134 1.2 2.8L9.867 26.8c.8.8 1.733 1.2 2.8 1.2h6.666c1.067 0 2.134-.4 2.8-1.2l4.667-4.667c.8-.8 1.2-1.733 1.2-2.8v-6.666c0-1.067-.4-2.134-1.2-2.8zM6.667 19.333v-6.666c0-.4.133-.667.4-.934l4.666-4.666c.267-.267.534-.4.934-.4h6.666c.4 0 .667.133.934.4l1.466 1.466-13.2 13.2-1.6-1.466c-.133-.267-.266-.534-.266-.934zm18.666 0c0 .4-.133.667-.4.934l-4.666 4.666c-.267.267-.534.4-.934.4h-6.666c-.4 0-.667-.133-.934-.4l-1.466-1.466 13.2-13.2 1.466 1.466c.267.267.4.534.4.934v6.666z"}})])])
          )
        }
      }
    